// extracted by mini-css-extract-plugin
export default {"toggleMenuButton":"toggle-menu-button-module__toggleMenuButton--Ws5YE"};